"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nul = void 0;
const interface_js_1 = require("./interface.js");
const options_js_1 = require("./options.js");
/**
 * Define a new attribute of null type
 *
 * @param options _(optional)_ Attribute Options
 */
const nul = (options) => {
    const state = {
        ...options_js_1.NULL_DEFAULT_OPTIONS,
        ...options,
        enum: undefined,
        defaults: { ...options_js_1.NULL_DEFAULT_OPTIONS.defaults, ...options === null || options === void 0 ? void 0 : options.defaults },
        links: { ...options_js_1.NULL_DEFAULT_OPTIONS.links, ...options === null || options === void 0 ? void 0 : options.links }
    };
    return new interface_js_1.$NullAttribute(state);
};
exports.nul = nul;
